import type { ReactNode } from "react";
import { cx } from "./cx";

/** Quem fez: pessoa da equipe, assistente (sempre com confirmação, §5.2) ou o tribunal. */
export type Origem = "pessoa" | "assistente" | "tribunal";

export type Evento = { id: string; quando: string; quem?: string | null; origem: Origem; texto: ReactNode };

const PONTO = { pessoa: "bg-conferir", assistente: "bg-pronto", tribunal: "bg-texto-3" } as const;

export function LinhaDoTempo({ eventos }: { eventos: Evento[] }) {
  return (
    <ol className="flex flex-col">
      {eventos.map((e, i) => (
        <li key={e.id} className="relative grid grid-cols-[0.75rem_1fr] gap-3 pb-4 last:pb-0">
          {i < eventos.length - 1 && <span aria-hidden className="absolute top-4 bottom-0 left-1 w-px bg-borda" />}
          <span aria-hidden className="flex h-5 items-center"><span className={cx("size-2 rounded-pilula", PONTO[e.origem])} /></span>
          <div className="min-w-0">
            <div className="break-words text-texto-1">{e.texto}</div>
            <p className="text-meta text-texto-3"><span className="numeros">{e.quando}</span>{e.quem && <> · {e.quem}</>}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
